import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { KeyValue } from '@angular/common';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { AppConstants } from '../../app.constants';
import { PlaylistItemDTO } from '../../core/models/view-models/playlist-item-models/playlist-item-dto.model';
import { MawChromeLauncherViewMode } from '../../core/enums/mcl-view-mode.enum';
import { RssTickerConfigs } from '../../core/models/entities/rss-ticker.type';
import { LaunchersService } from '../../core/services/http-services/launchers.service';
import { ModalConfigureItemBorderComponent } from '../../shared-module/components/_modals/modal-configure-item-border/modal-configure-item-border.component';
import { PlaylistItemBorderSettings } from '../../core/models/view-models/playlist-item-models/playlist-item-border-settings.model';
import { PlaylistItemType } from '../../core/models/enums/playlist-item-type.enum';

@Component({
  selector: 'mcl-mode-select',
  templateUrl: './mcl-mode-select.component.html',
  styleUrls: ['./mcl-mode-select.component.scss']
})
export class MclModeSelectComponent implements OnInit, OnDestroy {
  @Input() item: PlaylistItemDTO;
  @Input() rss: RssTickerConfigs;
  @Input() parentContainer: ElementRef;
  @Output() changeMode: EventEmitter<string> = new EventEmitter();

  public selectedMode: string;
  public modes = MawChromeLauncherViewMode;
  public showMawChromeOptions: boolean;
  public appConst = AppConstants;
  public playlistItemTypes = PlaylistItemType;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private readonly launchersService: LaunchersService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.launchersService.hideMawChromeSettings.subscribe(() => {
        this.showMawChromeOptions = false;
      })
    );

    this.setSelectedMawChromeMode();
  }

  toggleSelection(): void {
    this.showMawChromeOptions = !this.showMawChromeOptions;
  }

  onChangeMode(mode: KeyValue<string, string>): void {
    this.showMawChromeOptions = false;
    this.selectedMode = mode.key;
    this.changeMode.emit(mode.key);
  }

  onConfigureBorders(): void {
    const modal = this.dialog.open(ModalConfigureItemBorderComponent, AppConstants.MLC_BORDERS_DIALOG_WINDOW_CONFIG);
    modal.componentInstance.border = this.item.BordersSettings ?
      { ...this.item.BordersSettings } :
        new PlaylistItemBorderSettings();

    modal.afterClosed()
      .pipe(
        filter(borderSettings => !!borderSettings),
        take(1)
      )
      .subscribe((borderSettings: PlaylistItemBorderSettings) => {
        this.item.BordersSettings = borderSettings.Size ?
          borderSettings :
          null;
      });
  }

  originalOrder(): number {
    return 0;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private setSelectedMawChromeMode(): void {
    const viewModesKeys = Object.keys(MawChromeLauncherViewMode);

    if (this.item.LayoutSplitViewType) {
      this.selectedMode = viewModesKeys.find(mawChromeMode =>
        +mawChromeMode.split(AppConstants.MCL_MODE_ID_DELIMITER)[1] === this.item.LayoutSplitViewType);
    }
    else {
      this.selectedMode = viewModesKeys[0];
    }
  }
}
